// import useAuth from "./hooks/useAuth";

// export const useVerifyUserRole = () => {
// 	const { auth } = useAuth();

// 	const userRoles = auth?.user?.role?.split(",") || [];
// 	function verifyRole(...userRole) {
// 		const verifyRoles = [...userRole];
// 		// eslint-disable-next-line array-callback-return
// 		const truthTable = userRoles.map((role) => {
// 			if (verifyRoles.includes(role.trim())) {
// 				return true;
// 			}
// 		});
// 		if (!truthTable.includes(true)) return false;
// 		else return true;
// 	}
// 	return verifyRole;
// };


import useAuth from "./hooks/useAuth";
import { roles } from "./roles";

export const useVerifyUserRole = () => {
  const { auth } = useAuth();

  const userRoles =
    auth?.user?.role?.split(",").map(r => r.trim()) || [];

    console.log('User roles:', auth?.user);

  return (...allowedRoles) => {
    // SUPER_ADMIN can access everything
    if (userRoles.includes(roles.super_admin)) {
      return true;
    }

    // Check intersection
    return allowedRoles.some(role => userRoles.includes(role));
  };
};
